require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./posts-object-detection-with-rcnn.json") })
        }
      }, "path---posts-object-detection-with-rcnn");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---posts-object-detection-with-rcnn!./.cache/json/posts-object-detection-with-rcnn.json
// module id = 400
// module chunks = 231608221292675